import { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '../../juristec-ui/core/Popover';
import IconButton from '../../juristec-ui/core/IconButton';
import List from '../../juristec-ui/core/List';
import ListItem from '../../juristec-ui/core/ListItem';
import {
  Activate, Demote, Desactivate, Edit, MoreVert, Promote, Trash,
} from '../../juristec-ui/icons';

import { OptionsContainer } from './styled/UsersOption.styled';

const fileOptionsDefaultPropUser = {};
const fileOptionsDefaultPropCurrentUser = {};
const fileOptionsDefaultPropPromoteUser = () => {};
const fileOptionsDefaultPropDemoteUser = () => {};
const fileOptionsDefaultPropToggleUserState = () => {};
const fileOptionsDefaultPropDeleteUser = () => {};
const fileOptionsDefaultPropEditUser = () => {};

const FileOptions = ({
  user = fileOptionsDefaultPropUser,
  currentUser = fileOptionsDefaultPropCurrentUser,
  promoteUser = fileOptionsDefaultPropPromoteUser,
  demoteUser = fileOptionsDefaultPropDemoteUser,
  toggleUserState = fileOptionsDefaultPropToggleUserState,
  deleteUser = fileOptionsDefaultPropDeleteUser,
  editUser = fileOptionsDefaultPropEditUser,
  atModal = false,
}) => {
  const [openPopover, setOpenPopover] = useState(false);

  return user.role !== 'support' ? (
    <Popover
      offset={[0, 0]}
      open={openPopover}
      stayOpened={false}
      closePopover={() => setOpenPopover(false)}
      containerStyle={atModal ? { zIndex: '1050' } : {}}
      style={{ zIndex: '1050' }}
    >
      <Popover.Action>
        <IconButton
          size="medium"
          shape="rounded"
          style={{ padding: '1px' }}
          onClick={() => setOpenPopover(!openPopover)}
        >
          <MoreVert />
        </IconButton>
      </Popover.Action>
      <Popover.Content>
        <OptionsContainer style={atModal ? { zIndex: 1050 } : {}}>
          <List>
            {currentUser.uid !== user.uid ? (
              <>
                {!['support', 'super'].includes(user.role) && (
                  <ListItem onClick={() => promoteUser(user)} noOutline>
                    <Promote />
                    Promover
                  </ListItem>
                )}
                {user.role !== 'guest' && (
                  <ListItem onClick={() => demoteUser(user)} noOutline>
                    <Demote />
                    Rebaixar
                  </ListItem>
                )}
                <ListItem onClick={() => toggleUserState(user)} noOutline>
                  {user.disabled ? (
                    <>
                      <Activate />
                      Ativar
                    </>
                  ) : (
                    <>
                      <Desactivate />
                      Inativar
                    </>
                  )}
                </ListItem>
                <ListItem onClick={() => editUser(user)} noOutline>
                  <Edit />
                  Editar
                </ListItem>
                <ListItem onClick={() => deleteUser(user)} noOutline>
                  <Trash />
                  Excluir
                </ListItem>
              </>
            )
              : (
                <ListItem onClick={() => editUser(user)} noOutline>
                  <Edit />
                  Editar
                </ListItem>
              )}
            {/* TODO Falta fazer o historico
            <ListItem onClick={() => openUserHistory(user)} noOutline>
              <History />
              Histórico
            </ListItem>
            */}
          </List>
        </OptionsContainer>
      </Popover.Content>
    </Popover>
  ) : <></>;
};

FileOptions.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
    disabled: PropTypes.bool,
    uid: PropTypes.string,
  }),
  currentUser: PropTypes.shape({
    uid: PropTypes.string,
  }),
  promoteUser: PropTypes.func,
  demoteUser: PropTypes.func,
  toggleUserState: PropTypes.func,
  deleteUser: PropTypes.func,
  editUser: PropTypes.func,
  /**
   * Indicates if component is inside a modal
  */
  atModal: PropTypes.bool,
};

export default FileOptions;
